<template>
  <div id="remittance">
    
    <div class="wrapper">
      <div class="content">
        <div class="tip">
          <span>银行汇款支付成功后，我们会尽快为您审核，通过短信形式通知 审核进度(如已经支付订单，无需重复操作)。</span>
        </div>
        <div class="title">
          <img src="../../../assets/icon_pay_bank.png" />&nbsp;&nbsp;银行汇款
        </div>
        <div class="company">
          <div class="info" v-for="(value,index) in infos" :key="index">
            <div class="left">{{value.title}}</div>
            <div class="right" v-show="index<3">{{value.value}}</div>
            <div class="right" v-show="index===3">{{orderID}}</div>
          </div>
        </div>
      </div>
      <bottomButton title="汇款成功" :state="1" @click="payClick"></bottomButton>
      <el-dialog title="温馨提示" :visible.sync="successFlag" width="80%">
        <div class="title">
          <p class="tit">请输入汇款水单号：</p>
          <input maxlength="" class="input" type="text" v-model="numb">
          <div class="btnbox">
            <el-button class="btn" type="text" @click="sub(numb)">提交</el-button>
          </div>
        </div>
      </el-dialog>
      <successView :show="showSuccess" type="1" @successViewClick="successViewClick"></successView>
    </div>
  </div>
</template>

<script>
import bottomButton from '../../../components/bottom-button3'
import successView from '../../../components/success-view'
import wxshare from '../../../wx/weixin'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      reloadOrderId: 'MallOrderId'
    })
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('clearOrderId', '')
    // if (to.path === '/checkOrder') {
    //   next({
    //     path: '/orderListCenter',
    //     query: {
    //       status: 4,
    //       tag: 0
    //     }
    //   })
    // } else {
    //   next()
    // }
     next()
  },
  data () {
    return {
      numb: null,
      successFlag: false,
      showSuccess: false,
      infos: [
        { title: '公司名称：', value: '中消信息科技（上海）有限公司' },
        { title: '开户银行：', value: '交通银行上海黄浦支行' },
        { title: '银行账号：', value: '310066713018800091508' },
        { title: '订单编号：', value: '' }
      ],
      orderID: '', // 订单id
      type: '' // 银行汇款项目 类型 1 中消通 2 安全管家 3 风险评测一键解决 4 应急保障下单详情页 6 订单详情页
    }
  },
  methods: {
    back () {
      this.$router.back(-1)
    },
    payClick () {
      this.successFlag = true
      // var _this = this
      // this.utils.POST(this.companyUrl + '/zxOrder/update/' + this.$route.query.orderID, null, function (response) {
      //   console.log('银行汇款提交成功------------------')
      //   sessionStorage.removeItem('orderid') // 一键解决
      //   _this.showSuccess = true
      // })
    },
    sub (id) {
      if (id) {
        this.utils.POST(this.companyUrl + '/zxOrder/update/' + this.$route.query.orderID + '?remittanceId=' + id, null, response => {
          console.log('银行汇款提交成功------------------')
          sessionStorage.removeItem('orderid') // 一键解决
          this.showSuccess = true
          this.successFlag = false
        })
      }
    },
    successViewClick: function () {
      this.showSuccess = false
      this.$store.commit('clearOrderId', '')
      // this.$router.replace({
      //   path: '/orderListCenter',
      //   query: {
      //     status: 4,
      //     tag: 0
      //   }
      // })
    }
  },
  watch: {
    $router: {
    }
  },
  components: { // 注册组件
    bottomButton,
    successView
  },
  mounted () {
    wxshare.wxShareHomePage('【中消在线】消防安全产品一站式采购平台', '品质保障，正品低价，支持线上交易', 'http://cdn.zxzx119.com/1294196519632633856')
    this.orderID = this.$route.query.orderID
    // this.type = this.$route.query.type
  }
}
</script>

<style lang="scss" scoped>
#payBank {
  position: absolute;
  top: 55px;
  bottom: 0px;
  background-color: #f6f6f6;
  width: 100%;
  
}
 
.wrapper {
  position: relative;
}
.mainHeader {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
}
.content {
  width: 100%;
  height: 260px;
  background-color: #ffffff;
}
.content .tip {
  position: relative;
  font-size: 13px;
  color: #bebebe;
  height: 62px;
  margin: 0 15px 15px 15px;
  border-bottom: solid 1px #eeeeee;
  padding-top: 15px;
  box-sizing: border-box;
  line-height: 16px;
}
.content .tip span {
}
.content .title {
  position: relative;
  margin-left: 15px;
  font-size: 16px;
  color: #000000;
  height: 40px;
  line-height: 40px;
}
.content .title img {
  position: relative;
  top: 5px;
  width: 20px;
  height: 20px;
}
.content .company {
  position: relative;
  top: 10px;
  height: 90px;
  width: 100%;
}
.content .company .info {
  position: relative;
  height: 30px;
}
.content .company .info {
  position: relative;
  height: 30px;
  font-size: 15px;
}
.content .company .info .left {
  position: absolute;
  left: 15px;
  height: 30px;
  color: #000000;
}
.content .company .info .right {
  position: absolute;
  left: 100px;
  height: 30px;
  color: #808080;
}
/deep/ .el-dialog {
  border-radius: 10px;
  .el-dialog__header {
    border-radius: 10px 10px 0 0;
    padding-top: 10px;
    background: #c41335;
    .el-dialog__title {
      color: #ffffff;
    }
    .el-dialog__headerbtn {
      top: 10px;
      .el-dialog__close {
        color: #ffffff;
      }
    }
  }
  .el-dialog__body {
    padding-top: 60px;
  }
  .btnbox {
    text-align: center;
    .btn {
      display: inline-block;
      width: 120px;
      height: 40px;
      line-height: 40px;
      padding: 0;
      background: #c41335;
    color: #ffff;
    }
  }
  .tit {
    line-height: 18px;
    font-size: 16px;
    color: #000000;
    margin-bottom: 15px;
  }
  .input {
    width: 100%;
    line-height: 36px;
    height: 36px;
    display: inline-block;
    border: 1px solid #bdbdbd;
    text-indent: 5px;
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/shopping/shoppingCart/remittance.vue